
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ServerMailSpamFilterPage"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"serverMail"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"spamAssassin"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"settings"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isEnabled"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isUserSettingsEnabled"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isUserSettingsAllowed"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"requiredHits"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"maxMailLimit"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"maxThreadsLimit"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tag"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"alarmMessage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"languages"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isTrusted"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"locales"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isTrusted"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"isGreylistingProtectionEnabled"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"maxChildren"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"maxChildrenLimit"},"arguments":[],"directives":[]}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"capability"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mailServer"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isUserSettingsSupported"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"os"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isWindows"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":885}};
    doc.loc.source = {"body":"query ServerMailSpamFilterPage {\r\n    serverMail {\r\n        spamAssassin {\r\n            settings {\r\n                isEnabled\r\n                isUserSettingsEnabled\r\n                isUserSettingsAllowed\r\n                requiredHits\r\n                maxMailLimit\r\n                maxThreadsLimit\r\n                tag\r\n                alarmMessage\r\n                languages {\r\n                    key\r\n                    name\r\n                    isTrusted\r\n                }\r\n                locales {\r\n                    key\r\n                    name\r\n                    isTrusted\r\n                }\r\n                isGreylistingProtectionEnabled\r\n                maxChildren\r\n                maxChildrenLimit\r\n            }\r\n        }\r\n    }\r\n    capability {\r\n        mailServer {\r\n            isUserSettingsSupported\r\n        }\r\n    }\r\n    os {\r\n        isWindows\r\n    }\r\n}\r\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["ServerMailSpamFilterPage"] = oneQuery(doc, "ServerMailSpamFilterPage");
        
